var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "selector-color-container d-flex flex-row flex-wrap" },
    _vm._l(_vm.colors, function (color) {
      return _c(
        "div",
        {
          key: color,
          staticClass:
            "d-flex flex-row mr-2 mt-2 color-selector-item justify-content-center align-items-center clickable",
          class: { selected: _vm.isSelected(color) },
          style: _vm.getStyle(color, _vm.isSelected(color)),
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.handleSelect(color)
            },
          },
        },
        [
          _vm.isSelected(color)
            ? _c(
                "i",
                {
                  staticClass: "material-icons clickable bold font-sm",
                  style: { color: _vm.getCheckMarkColor(color) },
                },
                [_vm._v("check")]
              )
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }